import VMasker from 'vanilla-masker';
import removerAcentuacao from './removerAcentuacao';

function getValue(obj, keys, field) {
  let label = '';
  keys.forEach(key => {
    if (obj[key] && obj[key][field]) {
      label = obj[key][field];
    }
  });

  return label;
}

export default function convertGoogleResponseToAddress(location, place) {
  const locationData = [];

  for (let i = 0; i < place.address_components.length; i += 1) {
    const addressType = place.address_components[i].types[0];
    locationData[addressType] = place.address_components[i];
  }

  const isEstabelecimento = location.types.indexOf('establishment') >= 0;

  let telefone = '';
  if (place.formatted_phone_number) {
    telefone = String(place.formatted_phone_number)
      .replace(/[^0-9]/g, '')
      .padStart(10, '11');
    const pattern =
      telefone.length >= 11 ? '(99) 99999-9999' : '(99) 9999-9999';
    telefone = VMasker.toPattern(telefone, pattern);
  }

  let cidade = getValue(
    locationData,
    ['administrative_area_level_2'],
    'long_name',
  );

  if (cidade) {
    cidade = removerAcentuacao(cidade.toUpperCase());
  }

  return {
    endereco: getValue(locationData, ['route'], 'long_name'),
    numero: getValue(locationData, ['street_number'], 'long_name'),
    bairro: getValue(
      locationData,
      ['political', 'sublocality', 'sublocality_level_1'],
      'long_name',
    ),
    estado: getValue(
      locationData,
      ['administrative_area_level_1'],
      'short_name',
    ),
    cidade,
    cep: getValue(locationData, ['postal_code'], 'long_name'),
    nomeFantasia: isEstabelecimento
      ? location.structured_formatting.main_text
      : '',
    latitude: place.geometry.location.lat(),
    longitude: place.geometry.location.lng(),
    telefone,
  };
}
